define('services/auth/trial',['require','exports','module'],function (require, exports, module) {
  'use strict';

  var companyInfo = {},
    expirationCb,
    refresh = function (data) {
      data = data || {};
      companyInfo.type = data.type || 'freemium';
      companyInfo.endDate = data.endDate || '2014-12-31 00:00:00';
      companyInfo.maxCompanies = data.maxCompanies || 0;
      companyInfo.maxUsers = data.maxUsers || 0;
      companyInfo.maxVisits = data.maxVisits || 0;
      companyInfo.maxDomains = data.maxDomains | 0;
      companyInfo.correo_direct_is_available = !!data.correo_direct_is_available;
      companyInfo.isAppSumo = data.isAppSumo;
    },
    now = function () {
      return new Date().getTime();
    };

  module.exports = function () {
    return {
      get: function () {
        return companyInfo;
      },
      refresh: function (data) {
        refresh(data);
        if (expirationCb && this.hasExpired()) expirationCb();
      },
      clear: function () {
        companyInfo = {};
        this._setCookie(false);
        expirationCb = undefined;
      },
      getAccountType: function () {
        return companyInfo.type ? companyInfo.type : '';
      },
      isFreemium: function () {
        return companyInfo.type && companyInfo.type === 'freemium';
      },
      getMaxCompanies: function () {
        return companyInfo.maxCompanies ? companyInfo.maxCompanies : 0;
      },
      getMaxUsers: function () {
        return companyInfo.maxUsers ? companyInfo.maxUsers : 0;
      },
      getMaxDomains: function () {
        return companyInfo.maxDomains ? companyInfo.maxDomains : 0;
      },
      getTrialEndTime: function () {
        return new Date(companyInfo.endDate).getTime();
      },
      hasExpired: function () {
        return this.isFreemium() && now() >= this.getTrialEndTime();
      },
      hasBeenDisplayed: function () {
        return this._readCookie();
      },
      markAsDisplayed: function () {
        this._setCookie(true);
      },
      onExpiration: function (cb) {
        if (typeof cb === 'function') {
          expirationCb = cb;
        }
      },
      isMaxDomainsExceed: function (num) {
        return num >= this.getMaxDomains();
      },
      isAppSumo: function () {
        return companyInfo.isAppSumo;
      },
      _setCookie: function (shown) {
        document.cookie = 'trialpopupshown=' + shown + '; path=/';
      },
      _readCookie: function () {
        var value = document.cookie.match(/trialpopupshown=(true|false)/);
        return value && value[1] === 'true';
      },
    };
  };
});

